/* global axios */
import ApiClient from './ApiClient';

// Previa do segmento de contatos (spec 007): contagem, alcancaveis, excluidos por motivo e amostra.
class SegmentsAPI extends ApiClient {
  constructor() {
    super('segments', { accountScoped: true });
  }

  preview(query, { signal } = {}) {
    return axios.post(`${this.url}/preview`, { query }, { signal });
  }
}

export default new SegmentsAPI();
